import { render, staticRenderFns } from "./addorder.vue?vue&type=template&id=1a3d9b16"
import script from "./addorder.vue?vue&type=script&lang=js"
export * from "./addorder.vue?vue&type=script&lang=js"
import style0 from "./addorder.vue?vue&type=style&index=0&id=1a3d9b16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports